import {CustomerFieldClassificationEnum} from '../../../gql/customer/graphql.ts';

interface CustomerField {
    key?: string | null;
    name?: string | null;
    default?: boolean | null;
    classification?: string | null;
    show_public?: boolean | null;
    edit_public?: boolean | null;
}

interface OwnProps {
    disabled: boolean;
    customerField: CustomerField;
    defaultValue: string | null | undefined;
}

export function CustomerField({customerField, defaultValue, disabled}: OwnProps) {
    if (!customerField.key) {
        return null;
    }

    return (
        <label key={'custom-field-' + customerField.key}>
            {customerField.name}
            <input
                type={typeFromClassification(customerField.classification as CustomerFieldClassificationEnum)}
                name={customerField.key + (!customerField.edit_public ? '-disabled' : '')}
                defaultValue={defaultValue || undefined}
                disabled={disabled}
            />
        </label>
    );
}

function typeFromClassification(classification: CustomerFieldClassificationEnum | null | undefined): string {
    switch (classification) {
        case CustomerFieldClassificationEnum.Date:
            return 'date';
        case CustomerFieldClassificationEnum.Number:
            return 'number';
        default:
            return 'text';
    }
}
